'use strict';

exports.__esModule = true;
var KEY_PREFIX = exports.KEY_PREFIX = 'reduxPersist:';
var REHYDRATE = exports.REHYDRATE = 'persist/REHYDRATE';


//////////////////
// WEBPACK FOOTER
// ./~/redux-persist/lib/constants.js
// module id = 117
// module chunks = 0